
import React from "react";
import { Star, Filter } from "lucide-react";
import { CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useTranslation } from "react-i18next";

type TestType = "all" | "putting" | "chipping" | "wedging" | "bunker" | "iron" | "fairwayWood" | "driver";

interface FavoriteTestsHeaderProps {
  filterType: TestType;
  setFilterType: (type: TestType) => void;
}

const FavoriteTestsHeader: React.FC<FavoriteTestsHeaderProps> = ({ filterType, setFilterType }) => {
  const { t } = useTranslation('training');
  
  const getFilterLabel = (type: TestType) => {
    switch (type) {
      case "all": return t('favorites.allExercises');
      case "bunker": return t('favorites.categories.bunker');
      case "iron": return t('favorites.categories.iron');
      case "fairwayWood": return t('favorites.categories.fairwayWood');
      case "driver": return t('favorites.categories.driver');
      case "putting": return t('favorites.categories.putting');
      case "chipping": return t('favorites.categories.chipping');
      case "wedging": return t('favorites.categories.wedging');
      default: return t('favorites.filter');
    }
  };

  return (
    <CardHeader className="pb-3">
      <div className="flex justify-between items-center">
        <CardTitle className="text-xl flex items-center">
          <Star className="h-5 w-5 mr-2 text-amber-500 fill-amber-500" />
          {t('favorites.title')}
        </CardTitle>
        
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="sm" className="ml-auto h-8 gap-1">
              <Filter className="h-4 w-4" />
              {getFilterLabel(filterType)}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => setFilterType("all")}>
              {t('favorites.allExercises')}
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setFilterType("bunker")}>
              {t('favorites.categories.bunker')}
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setFilterType("iron")}>
              {t('favorites.categories.iron')}
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setFilterType("fairwayWood")}>
              {t('favorites.categories.fairwayWood')}
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setFilterType("driver")}>
              {t('favorites.categories.driver')}
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setFilterType("putting")}>
              {t('favorites.categories.putting')}
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setFilterType("chipping")}>
              {t('favorites.categories.chipping')}
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setFilterType("wedging")}>
              {t('favorites.categories.wedging')}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </CardHeader>
  );
};

export default FavoriteTestsHeader;
